import type { ReactNode } from "react";
import { Inbox, SearchX, type LucideIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export const VoltEmpty = ({
  icon: Icon = Inbox,
  title,
  description,
  action,
  className,
}: {
  icon?: LucideIcon;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
}) => (
  <div
    className={cn(
      "flex flex-col items-center gap-3 px-4 py-12 text-center",
      className,
    )}
  >
    <div className="flex size-12 items-center justify-center rounded-full bg-primary-soft text-primary">
      <Icon className="size-6" aria-hidden />
    </div>
    <h2 className="text-base font-semibold">{title}</h2>
    {description ? (
      <p className="max-w-sm text-sm text-muted-foreground">{description}</p>
    ) : null}
    {action ? <div className="mt-1">{action}</div> : null}
  </div>
);

export const VoltEmptyFiltered = ({ onReset }: { onReset: () => void }) => (
  <VoltEmpty
    icon={SearchX}
    title="Keine Treffer für diese Filter"
    description="Ändere die Suche oder entferne einen Filter."
    action={
      <Button variant="outline" onClick={onReset}>
        Filter zurücksetzen
      </Button>
    }
  />
);
